import React from "react";
import Button from "../Button";
import { useNavigate } from "react-router-dom";

const RoomCard = ({ name, users }) => {
	const navigator = useNavigate();

	const usersOtherThanFirst = users.slice(1);

	const handleJoinRoom = (e) => {
		navigator(`../room/${name}`);
	};

	return (
		<>
			<div className="container">
				<div className="cardContainer">
					<h1>Room: {name}</h1>
					<p>
						Users: {users[0]}
						{usersOtherThanFirst.map((user) => (
							<span>, {user}</span>
						))}
					</p>
					<Button
						text={
							<>
								Join<span aria-hidden></span>
								<span aria-hidden class="cybrBtnGlitch">
									Join
								</span>
							</>
						}
						onClick={handleJoinRoom}
					/>
				</div>
			</div>
		</>
	);
};

export default RoomCard;
